// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ApiErrorResponse } from "../schema";

export function serialize_ApiErrorResponse_internal(value: ApiErrorResponse): unknown {
  return ((value: { errorCode: string | null; errorMessage: string | null }): unknown => {
    return {
      errorCode: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["errorCode"]),
      errorMessage: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["errorMessage"]),
    };
  })(value);
}
export function serialize_ApiErrorResponse(obj: ApiErrorResponse): string {
  return renderJsonWithNumbersAsBigint(serialize_ApiErrorResponse_internal(obj));
}
export function deserialize_ApiErrorResponse_internal(value: unknown): ParserResult<ApiErrorResponse> {
  return ((
    value: unknown,
  ): ParserResult<{
    errorCode: string | null;
    errorMessage: string | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ApiErrorResponse]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ApiErrorResponse]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "errorCode")) {
      return { success: false, reason: `[#/components/schemas/ApiErrorResponse/errorCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'errorCode'.` };
    }
    const parsed_errorCode = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ApiErrorResponse/errorCode]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["errorCode"]);
    })();
    if (!parsed_errorCode.success) {
      return { success: false, reason: parsed_errorCode.reason };
    }
    if (!hasProp(value, "errorMessage")) {
      return { success: false, reason: `[#/components/schemas/ApiErrorResponse/errorMessage]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'errorMessage'.` };
    }
    const parsed_errorMessage = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ApiErrorResponse/errorMessage]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["errorMessage"]);
    })();
    if (!parsed_errorMessage.success) {
      return { success: false, reason: parsed_errorMessage.reason };
    }
    return { success: true, value: { errorCode: parsed_errorCode.value, errorMessage: parsed_errorMessage.value } };
  })(value);
}
export function deserialize_ApiErrorResponse(str: string): ParserResult<ApiErrorResponse> {
  return deserialize_ApiErrorResponse_internal(parseJsonWithNumbersAsBigint(str));
}
